module.exports = "data:image/gif;base64,R0lGODlhAQALAIAAAOXl5cTExCH5BAAAAAAALAAAAAABAAsAAAIEDIx3BQA7"


//////////////////
// WEBPACK FOOTER
// ./src/images/divider1.gif
// module id = 272
// module chunks = 0